export enum RentLicensesActions {
  LoadRentLicenses = 'Request rent licenses',
  DeleteRentLicense = 'Delete rent licenses',
  SaveRentLicenses = 'Save rent licenses',
  RentLicensesAccepted = 'rent licenses accepted',
}
